import { API_BASE_URL, ACCESS_TOKEN_NAME } from "@/config/serverApiConfig";

import axios from "axios";
import errorHandler from "@/request/errorHandler";
import successHandler from "@/request/successHandler";
import storePersist from "@/redux/storePersist";

import { getCookie, setCookie, deleteCookie } from "./cookie";

export const login = async (loginAdminData) => {
  try {
    const response = await axios.post(
      API_BASE_URL + `login?timestamp=${new Date().getTime()}`,
      loginAdminData
    );
    token.set(response.data.result.token);
    return successHandler(response);
  } catch (error) {
    return errorHandler(error);
  }
};

export const logout = () => {
  if (token) {
    token.remove();  // Make sure the `remove` method is defined to clear the token from localStorage, cookies, etc.
  }
  if (storePersist && storePersist.clear) {
    storePersist.clear();  // Ensure that your persistence library has a clear method for resetting state.
  }
  
  console.log("Logged out");
  window.location.href = '/login';  // This will redirect the user to the login page

};

export const token = {
  get: () => {
    console.log("Get token");
    return getCookie(ACCESS_TOKEN_NAME);
  },
  set: (token) => {
    console.log("Set token");
    return setCookie(ACCESS_TOKEN_NAME, token);
  },
  remove: () => {
    console.log("Removing token");
    return deleteCookie(ACCESS_TOKEN_NAME);
  },
};
